var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}})}
var staticRenderFns = []

export { render, staticRenderFns }